import new1 from "./news1.jpeg";
import new2 from "./news2.jpeg";

import coming from "../photos-coming-soon.jpg"

const news = [
  {
    id: 1,
    image: new2,
    name: "มหาวิทยาลัยราชภัฏธนบุรีร่วมลงนาม MOU กับสมาคมนวัตกรรมสิ่งแวดล้อม",
    data: "9 ธันวาคม 2568",
    context:
      "มหาวิทยาลัยราชภัฏธนบุรี จัดพิธีลงนามบันทึกความร่วมมือระหว่างมหาวิทยาลัยราชภัฏธนบุรี และสมาคมนวัตกรรมสิ่งแวดล้อม ",
    detail:
      "เมื่อวันที่ 9 ธันวาคม 2568  มหาวิทยาลัยราชภัฏธนบุรี จัดพิธีลงนามบันทึกความร่วมมือระหว่างมหาวิทยาลัยราชภัฏธนบุรี และสมาคมนวัตกรรมสิ่งแวดล้อม เพื่อร่วมกันพัฒนาองค์ความรู้ด้านสิ่งแวดล้อม เทคโนโลยีดิจิทัล นวัตกรรมและมาตรฐานอุตสาหกรรม การพัฒนาบุคลากรสำหรับอุตสาหกรรมอนาคต พร้อมรองรับความเปลี่ยนแปลงประเทศในยุคเศรษฐกิจคาร์บอนต่ำ (Low Carbon  Economy) การบังคับใช้กฎหมายด้านสิ่งแวดล้อมและคาร์บอนระดับสากล เช่น CBAM, Carbon Tax และ ETS รวมทั้งการพัฒนาศูนย์ความเป็นเลิศด้านนวัตกรรมและสิ่งแวดล้อม ห้องปฏิบัติการทดสอบมาตรฐาน (Testing & Certification)  "
      + "ศูนย์ฝึกอบรมด้านเทคโนโลยีอากาศยานไร้คนขับ (UAV) พื้นที่ Smart Campus โดยมี รศ.ดร.ปนัดดา ยิ้มสกุล อธิการบดี ร่วมลงนามในบันทึกข้อตกลงกับคุณสกุล อริยโชติมา นายกสมาคมนวัตกรรมสิ่งแวดล้อม ณ ห้องประชุมศรีเจริญ อาคาร 3 ชั้น 5 มหาวิทยาลัยราชภัฏธนบุรี ",
    detail2:  
      "รศ.ดร.ปนัดดา ยิ้มสกุล อธิการบดี เปิดเผยว่า การลงนามความร่วมมือในครั้งนี้เป็นโอกาสสำคัญของมหาวิทยาลัย ถือเป็นรากฐานในการพัฒนาสิ่งแวดล้อม การพัฒนาเทคโนโลยีอากาศยานไร้คนขับ (UAV)  การพัฒนาศูนย์ความเป็นเลิศด้านนวัตกรรมและสิ่งแวดล้อม การพัฒนามหาวิทยาลัยเป็นพื้นที่ Smart Campus และการพัฒนาบุคลากรเพื่อตอบโจทย์ของอุตสาหกรรมสมัยใหม่ ซึ่งการลงนามความร่วมมือครั้งเป็นจุดเริ่มต้นของความร่วมมือต่อไปในอนาคต  "
      + "ด้านคุณสกุล อริยโชติมา นายกสมาคมนวัตกรรมสิ่งแวดล้อม กล่าวว่า การลงนามความร่วมมือเป็นการวางฐานรากสำคัญของประเทศ เป็นการส่งโครงสร้างพื้นฐานความรู้ นวัตกรรม และระบบสนับสนุน โดยจะมีความร่วมมือในหลายมิติ เช่น การพัฒนาห้องปฏิบัติการทดสอบมาตรฐาน การจัดตั้งศูนย์อากาศยานไร้คนขับ การพัฒนา Smart Campus ซึ่งสมาคมจะผลักดันนโยบายด้านนวัตกรรมให้เกิดผลลัพธ์อย่างเป็นรูปธรรม ",
  },
  {
    id: 2,
    image: new1,
    name: "ประชุมคณะกรรมการบริหารสมาคม ครั้งที่ 1/2568",
    data: "7 พฤศจิกายน 2568",
    context:
      "สมาคมนวัตกรรมสิ่งแวดล้อม (Environmental Innovation Association: EInA) จัดประชุมคณะกรรมการบริหารสมาคม ครั้งที่ 1/2568 ณ โรงแรมเดอะ แกรนด์ โฟร์วิงส์ คอนเวนชั่น กรุงเทพฯ ",
    detail:
      "สมาคมนวัตกรรมสิ่งแวดล้อม (Environmental Innovation Association: EInA) จัดประชุมคณะกรรมการบริหารสมาคม ครั้งที่ 1/2568 ณ โรงแรมเดอะ แกรนด์ โฟร์วิงส์ คอนเวนชั่น กรุงเทพฯ ภายหลังจากที่ได้รับการจดทะเบียนจัดตั้งสมาคมอย่างเป็นทางการ เพื่อเปิดตัวและแถลงนโยบายการดำเนินงานระยะ 5 ปี (พ.ศ. 2568–2573) โดยมี สกุล อริยโชติมา นายกสมาคมนวัตกรรมสิ่งแวดล้อม เป็นประธานในที่ประชุม พร้อมด้วยคณะกรรมการบริหาร ที่ปรึกษา และสื่อมวลชนจากหลายภาคส่วน เข้าร่วมรับฟังนโยบายและทิศทางการทำงานของสมาคมฯ ที่มุ่งเน้น “ความร่วมมือและการบูรณาการทุกภาคี” เพื่อพัฒนาแนวทางนวัตกรรมสิ่งแวดล้อมของประเทศให้เป็นรูปธรรม ",
    detail2:  
      " นายสกุล อริยโชติมา เปิดเผยว่า การจัดตั้งสมาคมนวัตกรรมสิ่งแวดล้อมในครั้งนี้ เป็นการรวมพลังจากผู้เชี่ยวชาญ นักวิจัย นักอุตสาหกรรม และผู้บริหารองค์กรที่มีความมุ่งมั่นในการผลักดันประเทศไทยสู่ เศรษฐกิจสีเขียว (Green Economy) และ สังคมคาร์บอนต่ำ (Low Carbon Society) "
      + "“สมาคมฯ จะทำหน้าที่เป็น กลไกเชื่อมโยง (Connector) และ แพลตฟอร์มความร่วมมือ (Collaborative Platform) ระหว่างภาครัฐ เอกชน สถาบันการศึกษา ชุมชน และองค์กรระหว่างประเทศ เพื่อให้เกิดการเปลี่ยนผ่านด้านสิ่งแวดล้อมอย่างเป็นระบบและยั่งยืน” นายสกุล กล่าว ",
  },
  {
    id: 3,
    image: coming,
    name: "COMING SOON",
    data: "-",
    context:
      "-",
    detail:
      "-",
    detail2:
      "",   
  },
  {
    id: 4,
    image: coming,
    name: "COMING SOON",
    data: "-",
    context:
      "-",
    detail:
      "-",
    detail2:
      "",       
  },
  {
    id: 5,
    image: coming,
    name: "COMING SOON",
    data: "-",
    context:
      "-",
    detail:
      "-",
    detail2:
      "",    
  },
  {
    id: 6,
    image: coming,
    name: "COMING SOON",
    data: "-",
    context:
      "-",
    detail:
      "-",
    detail2:
      "",       
  },
];

export default news;
